// import { useTosatify } from "./useTosatify";

const useAudioContext = (arr, audioRef, setDuration, setIsPlaying, selectedVoice, fileFormatValue) => {

    const sampleRate = fileFormatValue === 'mu-law' ? 8000 :
        selectedVoice.vendor === 'elevenlabs' ? 44100 :
            selectedVoice.vendor === 'istnetworks' ? 22050 : 16000

    const audioContext = new AudioContext();
    audioRef.current = audioContext;
    const audioBuffer = audioContext.createBuffer(1, arr.length, sampleRate);
    const nowBuffering = audioBuffer.getChannelData(0);
    for (let i = 0; i < arr.length; i++) {
        nowBuffering[i] = arr[i] / 32768;
    }
    const audioSource = audioContext.createBufferSource();
    audioSource.buffer = audioBuffer;
    audioSource.connect(audioContext.destination);
    audioSource.start(audioContext.currentTime, 0, audioBuffer.duration, setIsPlaying(true));
    setDuration(audioBuffer.duration);
    audioSource.onended = () => {
        setIsPlaying(false);
        // useTosatify().tostifySuccess('a new Audio generated successfully');
    };
}

export { useAudioContext };